import { render, staticRenderFns } from "./menu-secondary.vue?vue&type=template&id=cb4a9528&scoped=true&"
import script from "./menu-secondary.vue?vue&type=script&lang=js&"
export * from "./menu-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4a9528",
  null
  
)

export default component.exports